import { render, staticRenderFns } from "./SmeInfoBox.vue?vue&type=template&id=0be80ae8&scoped=true&"
import script from "./SmeInfoBox.vue?vue&type=script&setup=true&lang=js&"
export * from "./SmeInfoBox.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./SmeInfoBox.vue?vue&type=style&index=0&id=0be80ae8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be80ae8",
  null
  
)

export default component.exports